import { render, staticRenderFns } from "./StudipIcon.vue?vue&type=template&id=7a117998&"
import script from "./StudipIcon.vue?vue&type=script&lang=ts&"
export * from "./StudipIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports